<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.relationship">
  <app-popup-header title="{{localService.languageContent.relationship.credits}}"></app-popup-header>
  <div class="modal-body" *ngIf="source" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="source.items.length == 0" style="text-align:center;">
      {{localService.languageContent.paging.no_records}}
    </div>
    <div *ngIf="source.items.length > 0">
      <div class="row styled_row" *ngFor="let item of source.items">
        <div class="col-md-8">
          <span class="en button" (click)="localService.showSummary(item.v5,1)">{{item.v6 | localDate}}</span>
          <span>&nbsp;:&nbsp;</span>
          <span class="en">{{item.v1 | number: '1.2-2'}}</span>
        </div>
        <div class="col-md-4">
          <span *ngIf="item.v3 == ''">{{item.v4}}</span>
          <span class="en button" *ngIf="item.v3 != ''" (click)="onRoute(item.v3, item.v2)">{{item.v4}}</span>          
        </div>
      </div>
    </div>
  </div>
</div>
